import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ClienteConFacturaAnticipada, MovimientoFacturaAnticipada } from "@shared/models/cliente/ClienteConFacturaAnticipada";
import { FacturacionService } from '@facturacion/facturacion.service';
import { ErrorModel } from "@shared/models/ErrorModel";
import { MessageService } from "@shell/message.service";
import { SharedService } from "@shared/shared.service";
import { AerovalesService } from '@despacho/aerovales.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { Comprobante } from "@shared/models/facturacion";
import { TipoMovimientoFacturaAnticipada } from "@shared/enums/TipoMovimientoFacturaAnticipada";
import { EstadoFacturaAnticipadaDevolucion } from "@shared/enums/EstadoFacturaAnticipadaDevolucion";
import { EstadoFacturaAnticipadaRecarga } from "@shared/enums/EstadoFacturacionAnticipadaRecarga";
import { AerovaleDetalle } from "@shared/models/despacho/AerovaleDetalle";
import { AerovaleDetalleComponent } from "@despacho/aerovale-detalle/aerovale-detalle.component";
import { VisorComprobanteComponent } from "@shared/visor-comprobante/visor-comprobante.component";
import { ClienteService } from '@cliente/cliente.service';
import { UsuarioService } from '@account/usuario.service';
import { ModalAnulacionAerovaleComponent } from '@despacho/modal-anulacion-aerovale/modal-anulacion-aerovale.component';
import { TipoMoneda } from '@shared/enums/tipoMoneda';

@Component({
  selector: 'app-reporte-anticipado',
  templateUrl: './reporte-anticipado.component.html',
  styleUrls: ['./reporte-anticipado.component.css']
})
export class ReporteAnticipadoComponent implements OnInit {
  esperandoCarga: boolean;
  clientes: ClienteConFacturaAnticipada[] = [];
  clientesFiltrados: ClienteConFacturaAnticipada[] = [];
  movimientos: MovimientoFacturaAnticipada[] = [];
  itemSeleccionado: number = null;
  cambiandoAeroplanta: boolean = false;
  codigoAeroplanta: string;
  /** scroll infinito */
  throttle = 500;
  distance = 2;
  page = 1;
  pageSize = 20;
  obteniendoDatosScroll:boolean;
  // aerovales
  aerovaleDetalle: AerovaleDetalle;
  obteniendoAerovale: boolean = false;
  aerovaleSeleccionado: number = null;
  anulandoAerovale: number;
  //comprobantes
  facturaObtenida: Comprobante = null;
  comprobanteSeleccionado: number = null;
  obteniendoComprobante: boolean = false;
  clientesRecibidos: ClienteConFacturaAnticipada[] = [];
  aerovalesIds: string[] = [];
  elementosChecked: number[] = [];
  model: NgbDateStruct;
  model1: NgbDateStruct;
  startDate: Date;
  endDate: Date;
  puedeAprobarFactura = false;

  protected readonly TipoMovimientoFacturacion = TipoMovimientoFacturaAnticipada;
  protected readonly EstadoFacturaAnticipadaDevolucion = EstadoFacturaAnticipadaDevolucion;
  protected readonly EstadoFacturaAnticipadaRecarga = EstadoFacturaAnticipadaRecarga;

  busquedasCliente = new UntypedFormGroup({
    clienteFormControl: new UntypedFormControl(),
    soloVigenteFormControl: new UntypedFormControl(false),
    fechaFormControlDesde: new UntypedFormControl(),
    fechaFormControlHasta: new UntypedFormControl()
  })

  constructor( private spinner: NgxSpinnerService,
               private calendar: NgbCalendar,
               private ngbDatepicker: NgbDatepickerConfig,
               private messageService: MessageService,
               private activeModal: NgbModal,
               private aerovaleService: AerovalesService,
               private facturacionService: FacturacionService,
               private comprobanteService: ComprobanteService,
               private sharedService: SharedService,
               private clienteService: ClienteService,
               private usuarioService: UsuarioService) { }

  ngOnInit() {
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.ngbDatepicker.minDate = inicio;
    const fin: any = { day: 31, month: 12, year: 2050};
    this.ngbDatepicker.maxDate = fin;
    this.fechaDesdeFormControl.setValue(this.model);
    this.fechaHastaFormControl.setValue(this.model1);
    this.setearFechaDesdeHasta();
    this.page=1;
    this.getClientes(this.page, false);
  }

  //Llamadas al service
  async getClientes(page: number, isScroll: boolean) {
    if(!isScroll) {
      this.handleSpinner(true);
    } else {
      this.mostrarSpinnerScroll();
    }

    try {
      this.clientesRecibidos = await this.clienteService.getClientesCuentaAnticipada(this.getFechaDesde(), this.getFechaHasta(), page, this.pageSize);

      if(!isScroll) {
        this.clientes = this.clientesRecibidos;
      } else {
        this.clientes = this.clientes.concat(this.clientesRecibidos);
      }

      for (let i = 0; i < this.clientes.length; i++) {
        this.clientes = this.clientes.sort((a, b) => { if (a.descripcion > b.descripcion) { return 1 } else { return -1 } });
      }
      this.clientesFiltrados = this.clientes;
      if(this.clientesFiltrados.length>0) {
        this.calcularSaldosPorCuentas();
      }
      if(!isScroll) {
        this.handleSpinner(false);
      } else {
        this.ocultarSpinnerScroll();
      }
    }
    catch (error) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos. ' + error.description);
      this.handleSpinner(false);
    }
  }

  /** Visualizar Aerovales */
  obtenerAerovale(id: string, i:number) {
    this.aerovaleDetalle = null;
    this.obteniendoAerovale = true;
    this.aerovaleSeleccionado=i;
    this.aerovaleService.getAerovalePorIdyTipo(id)
      .subscribe(result => {
        this.aerovaleDetalle = result;
        this.aerovaleSeleccionado= null;
        this.obteniendoAerovale = false;
        if(this.aerovaleDetalle.id) {
          this.mostrarAerovale();
        } else {
          this.messageService.showErrorMessage("Hubo un error al obtener el Aerovale");
        }
      }, (err: ErrorModel) => {
        this.messageService.showErrorMessage('Hubo un error al obtener el Aerovale' + err.description);
        this.aerovaleSeleccionado=null;
        this.obteniendoAerovale = false;
      });
  }

  handleSpinner(load: boolean) {
    this.esperandoCarga = load;
    load ? this.spinner.show('spinnerGrafico') : this.spinner.hide('spinnerGrafico');
  }

  mostrarSpinnerScroll() {
    this.obteniendoDatosScroll = true;
  }

  ocultarSpinnerScroll() {
    this.obteniendoDatosScroll = false;
  }

  onScrollSaldos(){
      this.getClientes(++this.page, true);
      this.filtroClientes();
  }

  mostrarAerovale() {
    const modalRef = this.activeModal.open(AerovaleDetalleComponent, { size: "lg", centered: true })
    modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;
  }

  /* Visualizar Factura */
  obtenerFactura(id: string, i: number) {
    this.facturaObtenida = null;
    this.obteniendoComprobante = true;
    this.comprobanteSeleccionado = i;
    this.comprobanteService.obtenerComprobantePorId(id)
      .subscribe(result => {
        this.facturaObtenida = result; //obtengo el comprobante segun id
        this.comprobanteSeleccionado = null;
        this.obteniendoComprobante = false;
        if (this.facturaObtenida != null) {
          const modalRef = this.activeModal.open(VisorComprobanteComponent, { centered: true, size: 'lg' });
          modalRef.componentInstance.facturaObtenida = this.facturaObtenida;
        } else {
          this.messageService.showErrorMessage('Error al obtener comprobante');
        }
      }, (error: ErrorModel)=>{
        this.comprobanteSeleccionado = null;
        this.messageService.showErrorMessage('Error al obtener comprobante: ' + error.description);
      });
  }

  aprobarFactura(){
    if (this.aerovalesIds.length > 0) {
      this.handleSpinner(true);
      this.puedeAprobarFactura = false;
      const aerovalesParaAprobar = {
        "AerovalesId": this.aerovalesIds,
        "Responsable": this.usuarioService.getNombresCompletosUsuario()
      }
      this.clienteService.aprobarFactura(aerovalesParaAprobar)
        .subscribe(() => {
          this.handleSpinner(false);
          this.messageService.showSuccessMessage("La factura se ha aprobado correctamente");
          this.getClientes(1, false);
        }, (error: ErrorModel) => {
          this.handleSpinner(false);
          this.messageService.showErrorMessage("Error al aprobar factura: " + error.description);
        });
      this.aerovalesIds = [];
      this.elementosChecked = [];
    } else {
      this.messageService.showErrorMessage("No existe el número de comprobante");
    }
  }

  //Validaciones y filtros
  campoSeleccionado(event: Event, estado: number, aerovaleId: string) {
    const inputElement = event.target as HTMLInputElement;
    this.aerovalesIds = this.aerovalesIds || [];
    this.elementosChecked = this.elementosChecked || [];
    if (inputElement.checked) {
      this.aerovalesIds.push(aerovaleId);
      this.elementosChecked.push(1);
    } else {
      this.aerovalesIds = this.aerovalesIds?.filter( element => element !== aerovaleId);
      this.elementosChecked.pop();
    }
    this.puedeAprobarFactura = (this.elementosChecked?.length > 0) && estado === EstadoFacturaAnticipadaRecarga.Facturado;
  }

  imprimir() {
    const printContents = document.getElementById('clientesPrint').innerHTML;
    this.sharedService.print(printContents);
  }

  calcularSaldosPorCuentas() {
    for (let i = 0; i < this.clientesFiltrados.length; i++) {
      let acum=0;
      this.clientesFiltrados[i].movimientosSaldo.forEach(e => {
        if(e.tipoMovimiento === this.TipoMovimientoFacturacion.SaldoAnterior) {
          acum = acum + e.cantidadLitros;
        } else if (!e.anulado && e.tipoMovimiento === this.TipoMovimientoFacturacion.Recarga && e.estadoSaldoRecarga == EstadoFacturaAnticipadaRecarga.Disponible) {
          acum = acum + e.cantidadLitros;
          if(e.saldoVencido) acum -= e.saldoVencido;
        } else if(!e.anulado && e.tipoMovimiento === this.TipoMovimientoFacturacion.Consumo || e.tipoMovimiento === this.TipoMovimientoFacturacion.Devolucion && (e.estadoSaldoDevolucion !== EstadoFacturaAnticipadaDevolucion.Pendiente && e.estadoSaldoDevolucion !== EstadoFacturaAnticipadaDevolucion.Rechazado)){
          acum = acum - e.cantidadLitros;
        }
        e.saldo=acum;
      });
      this.clientesFiltrados[i].saldoFinal = acum;
    }
  }

  getTipoMoneda(tipoMoneda) {
    if(tipoMoneda == TipoMoneda.PES) {
      return "$"
    } else return "USD "
  }

  buscarDesdeHasta() {
    this.clienteFormControl.setValue('');
    this.setearFechaDesdeHasta();
    this.page=1;
    this.getClientes(this.page,false);
  }

  fechasIncorrectas() {
    this.setearFechaDesdeHasta();
    return this.getFechaDesde() > this.getFechaHasta();
  }

  /** utiles */
  obtenerTipoMovimiento(tipo: number) {
    return this.TipoMovimientoFacturacion[tipo];
  }

  obtenerEstado(tipo: number) {
    return this.EstadoFacturaAnticipadaDevolucion[tipo];
  }

  obtenerEstadoRecarga(tipo: number) {
    return this.EstadoFacturaAnticipadaRecarga[tipo];
  }

  setearFechaDesdeHasta() {
    const desde = this.fechaDesdeFormControl?.value;
    const hasta = this.fechaHastaFormControl?.value;
    this.startDate = new Date(desde.year, desde.month - 1, desde.day);
    this.endDate = new Date(hasta.year, hasta.month - 1, hasta.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  anularAerovalePendiente(aerovaleId, index) {
    this.anulandoAerovale = index;
    this.aerovaleService.getAerovalePorIdyTipo(aerovaleId).subscribe(aerovaleDetalle => {
      this.anulandoAerovale = null;
      const modalRef = this.activeModal.open(ModalAnulacionAerovaleComponent, { centered: true, size: 'lg', backdrop: 'static' });
      modalRef.componentInstance.detalle = aerovaleDetalle;
      modalRef.result.then((result) => { 
        if (result) {
          this.getClientes(0, false);
        }
      });
    })
  }

  filtroClientes() {
    this.clientesFiltrados = this.clientes.filter(a => {
      let agregar = true;
      if (this.clienteFormControl.value) {
        agregar = a.descripcion.toLowerCase().indexOf(this.clienteFormControl.value.toLowerCase()) > -1;
        agregar = agregar || (a.ctA_SGC && a.ctA_SGC.toLocaleLowerCase().indexOf(this.clienteFormControl.value.toLocaleLowerCase()) > -1);
      }
      return agregar;
    });
  }

  filtroVigentes() {
    const soloVigentes = this.vigenciaFormControl.value;
    const fechaActual = new Date();

    if (!soloVigentes) {
      this.clientesFiltrados = this.clientes.map(cliente => {
        const movimientosFiltrados = cliente.movimientosSaldo.filter(movimiento => {
          if (movimiento.tipoMovimiento != TipoMovimientoFacturaAnticipada.SaldoAnterior){
            const fechaVigencia = new Date(movimiento.fechaHoraVigenciaHasta);
            return fechaVigencia > fechaActual;
          } else {
            return false;
          }
        });
        return { ...cliente, movimientosSaldo: movimientosFiltrados };
      }).filter(cliente => cliente.movimientosSaldo.length > 0);
    } else {
      this.clientesFiltrados = [...this.clientes];
    }
  }

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }

  getFechaDesde(){
    return this.formatDate(this.startDate.getFullYear(), this.startDate.getMonth() + 1, this.startDate.getDate(), 0, 0, 0);
  }

  getFechaHasta(){
    return this.formatDate(this.endDate.getFullYear(), this.endDate.getMonth() + 1, this.endDate.getDate(), 23, 59, 59);
  }

  //Getters y setters
  get clienteFormControl() {
    return this.busquedasCliente.get('clienteFormControl');
  }

  get vigenciaFormControl(){
    return this.busquedasCliente.get('soloVigenteFormControl');
  }

  get fechaDesdeFormControl(){
    return this.busquedasCliente.get('fechaFormControlDesde');
  }

  get fechaHastaFormControl(){
    return this.busquedasCliente.get('fechaFormControlHasta');
  }
}
